import { render, staticRenderFns } from "./ExAlert.vue?vue&type=template&id=bf3e7fcc&scoped=true"
import script from "./ExAlert.vue?vue&type=script&lang=js"
export * from "./ExAlert.vue?vue&type=script&lang=js"
import style0 from "./ExAlert.vue?vue&type=style&index=0&id=bf3e7fcc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../account/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bf3e7fcc",
  null
  
)

export default component.exports